import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { ENDPOINTS, StudyMedicalHistoryResponse } from '@/api';
import { fetcher } from '@/api/fetcher';
import { useStudyGuard } from '@/shared/guard';
import { useHiStudyStore } from '@/store';

export const useStudyMedicalHistoryQuery = () => {
  const { studyId } = useStudyGuard();

  const { setMedicalHistory } = useHiStudyStore();

  const fetchMedicalHistory = async () => {
    const { data } = await fetcher.HI.get<StudyMedicalHistoryResponse>(
      `${ENDPOINTS.HI.STUDY}${studyId}/medical-history`,
    );

    return data;
  };

  const {
    data: studyMedicalHistoryData,
    error,
    isLoading,
  } = useQuery({
    enabled: !!studyId,
    queryFn: fetchMedicalHistory,
    queryKey: ['medicalHistory', studyId],
  });

  useEffect(() => {
    if (studyMedicalHistoryData) {
      setMedicalHistory(studyMedicalHistoryData);
    }
  }, [studyMedicalHistoryData]);

  return { data: studyMedicalHistoryData, error, isLoading };
};
